import jwt_decode from 'jwt-decode';

const GetAgentNameAndId: any = (nameToken) => {
  if (nameToken) {
    return jwt_decode(nameToken);
  }
};

export default GetAgentNameAndId;
